var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, } from 'react';
import { StyledTitleGridBorder, StyledGridBorder, StyledTitleGridBorder2, StyledGridBorder2, StyledGridBorderNoChild, } from 'component/material/StyledGrid';
import { withStyles, Grid, Divider, Hidden } from '@material-ui/core';
import { isNumber, isString } from 'component/consts';
/** 字串條件加上紅色 * (requeird) */
export var requiredSign = function (text, needMark) {
    if (text === void 0) { text = ''; }
    if (needMark === void 0) { needMark = true; }
    return (React.createElement(React.Fragment, null,
        needMark ? React.createElement("span", { style: { color: 'red' } }, "*") : '',
        text));
};
/** 字串、元件斷行 */
export var strBreak = function (textArray) {
    if (textArray === void 0) { textArray = []; }
    return (React.createElement(React.Fragment, null, textArray.map(function (obj, idx) { return (React.createElement("div", { key: String(idx) }, obj)); })));
};
/** 字串、元件斷行 (分隔線) */
export var strDivider = function (textArray) {
    if (textArray === void 0) { textArray = []; }
    return (React.createElement(React.Fragment, null, textArray.map(function (obj, idx) { return (React.createElement(Fragment, { key: String(idx) },
        idx > 0 && React.createElement(Divider, { style: { backgroundColor: '#FFFF' } }),
        React.createElement("div", null, obj))); })));
};
var Max12 = function (value, valueO) { return (value > 12 ? valueO : value); };
var checkCol = function (colWs, dWs) {
    var width = colWs[0] + colWs[1];
    if (!colWs ||
        colWs.length !== 2 ||
        !isNumber(colWs[0]) ||
        !isNumber(colWs[1]) ||
        width / 12 > 1 ||
        12 % width !== 0) {
        return dWs;
    }
    return colWs;
};
// component-------------------------------------------------
export var PlainText = function (props) {
    var children = props.children, style = props.style, other = __rest(props, ["children", "style"]);
    return (React.createElement("div", __assign({ style: __assign({ fontSize: '1.1em', margin: '5px' }, style) }, other), children));
};
export var VcGrid = withStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
})(Grid);
export var VcEGrid = withStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
})(Grid);
export var HVcGrid = withStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
})(Grid);
export var TildeGrid = function (props) {
    var _a = props.style, style = _a === void 0 ? {} : _a, _b = props.children, children = _b === void 0 ? '~' : _b, other = __rest(props, ["style", "children"]);
    return (React.createElement("div", __assign({}, other, { style: __assign({ color: '#656565', padding: '0 5px' }, style) }), children));
};
export var MasterGrids = function (props) {
    var id = props.id, _a = props.mGrids, mGrids = _a === void 0 ? [] : _a;
    var _b = props.md, md = _b === void 0 ? [2, 4] : _b, _c = props.xs, xs = _c === void 0 ? [3, 9] : _c;
    md = checkCol(md, [2, 4]);
    xs = checkCol(xs, [3, 9]);
    var mdW = (md[0] + md[1]);
    var xsW = (xs[0] + xs[1]);
    return (React.createElement(Grid, { id: id, container: true }, mGrids.map(function (obj, idx) {
        // 1. 取出 noBorder
        var _a = obj.show, show = _a === void 0 ? true : _a, t = obj.t, child = obj.child, _b = obj.colspan, colspan = _b === void 0 ? 1 : _b, _c = obj.noBorder, noBorder = _c === void 0 ? false : _c;
        // 2. 定義一個動態的樣式物件
        var borderStyle = noBorder
            ? { border: 'none', boxShadow: 'none' }
            : {};
        var tdMd = (md[1] + (colspan - 1) * mdW);
        var tdXs = (xs[1] + (colspan - 1) * xsW);
        // 3. 在渲染元件的地方注入 style={borderStyle}
        var noTitleChild = child ? (React.createElement(StyledGridBorder, { item: true, md: mdW, xs: xsW, style: borderStyle }, child)) : (React.createElement(Hidden, { smDown: true },
            React.createElement(StyledGridBorderNoChild, { item: true, md: mdW, xs: xsW, style: borderStyle })));
        return (React.createElement(Fragment, { key: String(t + String(idx)) }, show &&
            (t === false ? (noTitleChild) : (React.createElement(React.Fragment, null,
                React.createElement(StyledTitleGridBorder, { item: true, md: md[0], xs: xs[0] },
                    React.createElement(PlainText, { style: { margin: '5px 0', textAlign: 'right' } }, isString(t) && t[0] === '*' ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { style: { color: 'red', display: 'contents' } }, "*"),
                        t.substring(1))) : (t))),
                React.createElement(StyledGridBorder, { item: true, md: Max12(tdMd, md[1]), xs: Max12(tdXs, xs[1]), style: borderStyle }, child))))));
    })));
};
export var MasterGrids2 = function (props) {
    var id = props.id, _a = props.mGrids, mGrids = _a === void 0 ? [] : _a;
    var _b = props.md, md = _b === void 0 ? [2, 4] : _b, _c = props.xs, xs = _c === void 0 ? [3, 9] : _c;
    md = checkCol(md, [2, 4]);
    xs = checkCol(xs, [3, 9]);
    var mdW = (md[0] + md[1]);
    var xsW = (xs[0] + xs[1]);
    return (React.createElement(Grid, { id: id, container: true }, mGrids.map(function (obj, idx) {
        var _a = obj.show, show = _a === void 0 ? true : _a, t = obj.t, child = obj.child, _b = obj.colspan, colspan = _b === void 0 ? 1 : _b;
        var tdMd = (md[1] + (colspan - 1) * mdW);
        var tdXs = (xs[1] + (colspan - 1) * xsW);
        return (React.createElement(Fragment, { key: String(t + String(idx)) }, show &&
            (t === false ? (React.createElement(StyledGridBorder2, { item: true, md: mdW, xs: xsW }, child)) : (React.createElement(React.Fragment, null,
                React.createElement(StyledTitleGridBorder2, { item: true, md: md[0], xs: xs[0] },
                    React.createElement(React.Fragment, null, isString(t) && t[0] === '*' ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { style: { color: 'red', display: 'contents' } }, "*"),
                        t.substring(1))) : (t))),
                React.createElement(StyledGridBorder, { item: true, md: Max12(tdMd, md[1]), xs: Max12(tdXs, xs[1]) }, child))))));
    })));
};
